import Vue from 'vue'
import Vuex, { ActionContext } from 'vuex'
import auth from '@/store/modules/auth'
import roomservice from '@/store/modules/roomservice'
import administration from '@/store/modules/administration'
import ui from '@/store/modules/ui'
import { IAuthState } from './modules/auth/state'
import { IRoomserviceState } from './modules/roomservice/state'
import { IUiState } from './modules/ui/state'
import { AxiosPromise } from 'axios'
import { AlrContainer } from '@/models/response/AlrContainer'
import { AloError } from '@/models/alo/AloError'
import { ApiResultCode } from '@/enum/ApiResultCode'
import { StateItem } from '@/models/alo/StateItem'
import { AloBase } from '@/models/alo/AloBase'
import  types from '@/store/all-action-types'
import cloneDeep from 'clone-deep'
import { IAdministrationState } from './modules/administration/state'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export interface IRootState {  
  auth: IAuthState
  roomservice:IRoomserviceState  
  administration:IAdministrationState
  ui:IUiState
}

const store = new Vuex.Store<IRootState>({    
  modules: {
    auth,
    roomservice,
    administration,
    ui
  },  
  strict: debug
})

export default store

const initialStateCopy = cloneDeep(store.state)

export function resetState() {        
  const state = cloneDeep(initialStateCopy) as IRootState     
  state.auth.authStatus = store.state.auth.authStatus
  state.auth.redirectPath = store.state.auth.redirectPath  
  store.replaceState(state)  
}

export function loadInitalData() {
  store.dispatch(types.ROOM_SERVICES_DATAS_ENSURE)
}

export const emptyAction = <T,TS>(context: ActionContext<TS, IRootState>,
  resquestCommit:string,
  successCommit:string,
  errorCommit:string,
  emptyRequest: () => AxiosPromise<AlrContainer<T>>,
  commit:boolean = true ) => {
  return new Promise<T>((resolve, reject) => {
    context.commit(resquestCommit)
    emptyRequest()
      .then(resp => {        
        if (resp.data.resultCode == ApiResultCode.Ok) {
          const item = resp.data.data as T            
          if(commit) context.commit(successCommit, item)
          resolve(item)            

        } else {            
          if(commit) context.commit(errorCommit)
          reject((resp.data.data as AloError).errorMessage)
        }
      })
      .catch(err => {          
        if(commit) context.commit(errorCommit)
        reject(err)
      })
  })
}

export const payloadAction = <T,TS>(context: ActionContext<TS, IRootState>,
    resquestCommit:string,
    successCommit:string,
    errorCommit:string,
    payloadRequest: (payload:any) => AxiosPromise<AlrContainer<T>>, 
    payload:any,
    commit:boolean = true,
    addPayloadToCommit = false,
  ) => {
  return new Promise<T>((resolve, reject) => {
    if(commit) addPayloadToCommit?context.commit(resquestCommit,payload):context.commit(resquestCommit)
    payloadRequest(payload)
      .then(resp => {
        if (resp.data.resultCode == ApiResultCode.Ok) {
          const item = resp.data.data as T            
          if(commit) context.commit(successCommit, addPayloadToCommit?{item,payload}:item)
          resolve(item)            

        } else {            
          if(commit) addPayloadToCommit?context.commit(errorCommit,payload):context.commit(errorCommit)
          reject((resp.data.data as AloError).errorMessage)
        }
      })
      .catch(err => {          
        if(commit) addPayloadToCommit?context.commit(errorCommit,payload):context.commit(errorCommit)
        reject(err)
      })
  })
}

export const actionEnsure = <T,TS>(context: ActionContext<TS, IRootState>,resquestAction:string, stateItemToCheck:StateItem<any>|null, id?:number ) => {    
  if(!stateItemToCheck || stateItemToCheck.expireAt < new Date()) {    
    return id?context.dispatch(resquestAction,id):context.dispatch(resquestAction)
  }
  return new Promise<T>((resolve, reject) => {
    resolve(stateItemToCheck.item)
  })
}